module.exports = __webpack_public_path__ + "img/leg-right-side.4ca29e32.png";